const GREEK_SECTION_NAMES = {
  "Electrical design": "Ηλεκτρολογικός σχεδιασμός",
  "Physical layout": "Φυσική διάταξη",
};

export function pendingSectionSaveMessage(names, isGreek) {
  if (!isGreek) {
    const list = names.join(" and ");
    return (
      `The ${list} tab${names.length > 1 ? "s have" : " has"} unsaved changes. ` +
      `Save ${names.length > 1 ? "them" : "it"} with the tab's own Save button first, then save the project.`
    );
  }

  const tabs = names.map((name) => `«${GREEK_SECTION_NAMES[name] || name}»`);
  const list = tabs.join(" και ");
  return names.length === 1
    ? `Η καρτέλα ${list} έχει μη αποθηκευμένες αλλαγές. Αποθηκεύστε πρώτα τη συγκεκριμένη καρτέλα με το δικό της κουμπί αποθήκευσης και έπειτα αποθηκεύστε το έργο.`
    : `Οι καρτέλες ${list} έχουν μη αποθηκευμένες αλλαγές. Αποθηκεύστε πρώτα καθεμία με το δικό της κουμπί αποθήκευσης και έπειτα αποθηκεύστε το έργο.`;
}
